import React from 'react';
import { LandingPage } from './LandingPage';
import { LanguageProvider } from '../contexts/LanguageContext';
import { UserProvider } from '../contexts/UserContext';

export const BiigApp: React.FC = () => {
  return (
    <UserProvider>
      <LanguageProvider>
        <LandingPage />
      </LanguageProvider>
    </UserProvider>
  );
};